import { createSelector } from "@reduxjs/toolkit";

export const isAuthenticatedSelector = createSelector<[(state: LSStore.State) => LSCommon.Models.UserJsModel], boolean>(state => state.user.value, user => user.id != null && user.id != Guid.Empty);
